// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Invoice_wrapper__9LEPj","anchor":"Invoice_anchor__5ykel","label":"Invoice_label___A_y2","icon":"Invoice_icon__3iujz"};